import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash, faEye, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { Dropdown } from "react-bootstrap";
import { forwardRef, useState } from "react";
import positions from "@serie3/freelancesplaceapi/api/finance/positions";
import PositionDomain from "@serie3/freelancesplaceapi/Domain/Billing/Outgoing/Position";

const DotsToggle = forwardRef(({ onClick }, ref) => {
  const [hovered, setHovered] = useState(false);
  return (
    <button ref={ref}
      onClick={(e) => { e.preventDefault(); onClick(e); }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? "#f0f0f0" : "transparent", border: "none",
        borderRadius: "8px", width: "30px", height: "30px",
        display: "flex", alignItems: "center", justifyContent: "center",
        cursor: "pointer", color: "#9e9e9e", fontSize: "0.9rem",
        transition: "background 0.15s", padding: 0,
      }}
    >
      <FontAwesomeIcon icon={faEllipsisVertical} />
    </button>
  );
});

const cellStyle = {
  padding: "12px 12px",
  verticalAlign: "middle",
  borderBottom: "1px solid #f5f5f5",
  fontSize: "0.88rem",
  color: "#424242",
};

const numCell = {
  ...cellStyle,
  textAlign: "right",
  fontVariantNumeric: "tabular-nums",
  color: "#424242",
};

const PositionRow = ({
  index, position, setShowRowEdit, deleteFunction,
  setShowPosition, showDropdowns = true,
}) => {
  const [hovered, setHovered] = useState(false);

  const Dropdowns = () => (
    <Dropdown>
      <Dropdown.Toggle as={DotsToggle} />
      <Dropdown.Menu
        popperConfig={{ strategy: "fixed" }}
        renderOnMount
        style={{
          borderRadius: "10px", boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
          border: "1px solid #f0f0f0", padding: "6px", minWidth: "140px",
        }}
      >
        {[
          { icon: faEye,   label: "View",   bg: "#e8f0fe", color: "#1a73e8", action: () => setShowPosition(position) },
          { icon: faEdit,  label: "Edit",   bg: "#e8f5e9", color: "#2e7d32", action: () => setShowRowEdit(position) },
          { icon: faTrash, label: "Delete", bg: "#ffebee", color: "#c62828", action: () => deleteFunction(index, positions.del(position.id)), textColor: "#c62828" },
        ].map(({ icon, label, bg, color, action, textColor }, i) => (
          <div key={label}>
            {i > 0 && <div style={{ height: "1px", background: "#f5f5f5", margin: "4px 0" }} />}
            <Dropdown.Item as="div" onClick={action} style={{
              display: "flex", alignItems: "center", gap: "10px",
              padding: "8px 12px", borderRadius: "7px",
              fontSize: "0.88rem", fontWeight: 500, color: textColor || "#424242", cursor: "pointer",
            }}>
              <span style={{
                width: "26px", height: "26px", borderRadius: "6px",
                background: bg, color, display: "flex", alignItems: "center",
                justifyContent: "center", fontSize: "0.75rem", flexShrink: 0,
              }}>
                <FontAwesomeIcon icon={icon} />
              </span>
              {label}
            </Dropdown.Item>
          </div>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );

  return (
    <tr
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ background: hovered ? "#f5f9ff" : "#fff", transition: "background 0.12s" }}
    >
      <td style={{ ...cellStyle, textAlign: "center", color: "#bdbdbd", fontWeight: 600, fontSize: "0.8rem" }}>
        {index + 1}
      </td>
      <td style={cellStyle}>
        <div style={{ fontWeight: 600, color: "#212121", marginBottom: "2px" }}>
          {position.titel}
        </div>
        {position.beschreibung && (
          <div style={{
            fontSize: "0.8rem", color: "#9e9e9e",
            overflow: "hidden", whiteSpace: "nowrap",
            textOverflow: "ellipsis", maxWidth: "260px",
          }}>
            {position.beschreibung}
          </div>
        )}
      </td>
      <td style={numCell}>{position.preis} €</td>
      <td style={numCell}>{position.multiplikator}</td>
      <td style={numCell}>{position.steuersatz}%</td>
      <td style={numCell}>{PositionDomain.calculatePositionNett(position)} €</td>
      <td style={{ ...numCell, color: "#9e9e9e" }}>{PositionDomain.calculatePositionTax(position)} €</td>
      <td style={{ ...numCell, fontWeight: 700, color: "#2e7d32" }}>
        {PositionDomain.calculatePositionGross(position)} €
      </td>
      {showDropdowns && (
        <td style={{ ...cellStyle, padding: "0 8px" }}>
          <Dropdowns />
        </td>
      )}
    </tr>
  );
};

export default PositionRow;
